const name = "@justifi/webcomponents";
const version = "5.5.0";
var packageJson = {
	name: name,
	version: version};

export { packageJson as p };
